
// $(window).on("resize", function(){
//     var myPos =  $(".sm_wrapper").offset().top;
//     $(".sm_wrapper").attr("data-myPos", myPos);
// })
$(window).on("load", function(){
  if($(".sm_wrapper").length){
    setMyPosition($(".sm_wrapper"));
  }
  if($(".content-right .quote-widget").length){
    setMyPosition($(".content-right .quote-widget"));
  }
})
$(window).scroll(function () {
if($(window).width() > 1024){
    if($(".article-detail .sm_wrapper").length){
      makeMeSticky($(".article-detail .sm_wrapper"), $(this));
    }
    if($(".article-detail .content-right .quote-widget").length){
      makeMeSticky($(".article-detail .content-right .quote-widget"), $(this));
    }
  }
})
function setMyPosition(elem){
  var myPos =  elem.offset().top;
  elem.attr("data-myPos", myPos);
}
function makeMeSticky(elem, wnd){
  var wY = wnd.scrollTop();
  var smY = elem.offset().top;
  var contentPos = $(".article-detail .content-left").offset().top + $(".article-detail .content-left").height();

  if(wY+140 >= smY){
    elem.hide();
    elem.addClass("fixMe");
    elem.show();
  }
  if(wY+60 < elem.attr("data-myPos")){
    elem.hide();
    elem.removeClass("fixMe");
    elem.show();
  }
  if(wY > contentPos-480){
    // console.log(wY +" -- "+ (contentPos-500));
    elem.hide();
    elem.removeClass("fixMe");
    elem.show();
  }
}
